/*
 * @providesModule URLConstants
 */

const URLConstants = {
  // Legal and support URLs
  USER_TERMS_AND_CONDITIONS: 'https://www.skillz.com/legal/#user-terms',
  PRIVACY_POLICY: 'https://www.skillz.com/privacy-policy/',
  SUPPORT_EMAIL: 'mailto:support@skillz.com',
} as const;

export default URLConstants;
